import { render, staticRenderFns } from "./ReportForm.vue?vue&type=template&id=44047202&scoped=true"
import script from "./ReportForm.vue?vue&type=script&lang=js"
export * from "./ReportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44047202",
  null
  
)

export default component.exports